import type { CSSProperties } from "react";
import { useTranslation } from "react-i18next";

import styles from "./styles.module.css";

interface MemberCardProps {
  name: string;
  role: string;
  program: string;
  focus: string;
  statement: string;
  accent?: string;
}

export function MemberCard({ name, role, program, focus, statement, accent }: MemberCardProps) {
  const { t } = useTranslation("components");

  return (
    <article
      className={styles.card}
      data-reveal
      style={accent ? ({ ["--member-accent"]: accent } as CSSProperties) : undefined}
    >
      <div className={styles.head}>
        <span className={styles.avatar} aria-hidden="true">
          {name.charAt(0)}
        </span>
        <div>
          <h3 className={styles.name}>{name}</h3>
          <p className={styles.role}>{role}</p>
        </div>
      </div>
      <dl className={styles.meta}>
        <div>
          <dt>{t("memberCard.program")}</dt>
          <dd>{program}</dd>
        </div>
        <div>
          <dt>{t("memberCard.focus")}</dt>
          <dd>{focus}</dd>
        </div>
      </dl>
      <p className={styles.statement}>{statement}</p>
    </article>
  );
}

export default MemberCard;
